import Sidebar from '../utill/Sidebar'
import Header from "../utill/Header";
import Footer from "../utill/Footer";
import {Card, Form, Table} from "react-bootstrap";
import React, {ChangeEvent, useContext, useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import axios from "axios";
import Url from "../utill/Url";
import {useSelector} from "react-redux";
import {reissue} from "../utill/UtilComponent";
import styles from "../../css/Authority.module.css";
import {RootState} from "../../redux/store";

function ClientModify() {
    const url = useContext(Url)
    const location = useLocation();
    const navigate = useNavigate();
    const selectCustomerCode = location.state?.customerCode
    const user = useSelector((state: RootState) => state.user.value);
    const auth = useSelector((state: RootState) => state.loginAuth.value);
    const [customer, setCustomer] = useState({
        customerCode: location.state?.customerCode,
        customerName: location.state?.customerName,
        description: location.state?.description,
        deleteYn: location.state?.deleteYn,
        loginId: location.state?.loginId
    });

    let userId = user.id;

    useEffect(() => {
        document.title = 'Mcon 모니터링 시스템-고객사 수정'
        if (auth.MENUAUTH?.SET0200?.readAuthorityYn !== "1" && auth.MENUAUTH?.SET0200?.writeAuthorityYn !== "1") {
            alert('페이지를 볼 수 있는 권한이 없습니다.');
            navigate(auth.firstUrl);
        }
        else if (auth.MENUAUTH?.SET0200?.writeAuthorityYn !== "1") {
            alert('페이지를 볼 수 있는권한이 없습니다')
            navigate('/ClientManagement')
        }
    }, [])

    const handleUpdateClient = async (e: React.MouseEvent<HTMLButtonElement>) => {
        reissue(userId, url, navigate).then(() => {
            e.preventDefault();
            const Update = window.confirm(`고객사 코드: ${selectCustomerCode}님의 정보를 수정하시겠습니까?`)
            if (Update) {
                axios.put(url + 'customercode/update', {
                    customerCode: selectCustomerCode,
                    customerName: customer.customerName,
                    description: customer.description,
                    loginId: userId
                }, {
                    headers: {
                        'Authorization': localStorage.getItem('Authorization')
                    }
                })
                    .then(res => {
                        alert('유저 정보가 수정되었습니다.');
                        navigate('/clientManagement');
                    })
                    .catch(error => {
                        console.log(error);
                        alert('유저 정보 수정에 실패하였습니다.');
                    });
            } else {
                console.log(e);
            }
        })
    }

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        setCustomer({...customer, [e.target.name]: e.target.value});
    };

    const handleDeleteClient = () => {
        reissue(userId, url, navigate).then(() => {
            const Delete = window.confirm(`고객사 코드: ${selectCustomerCode}의 정보를 삭제 하시겠습니까?`);
            if (Delete) {
                try {
                    axios.put(url + 'customercode/delete', {
                        customerCode: customer.customerCode,
                        customerName: customer.customerName,
                        description: customer.description,
                        deleteYn: "1",
                        loginId: userId
                    }, {
                        headers: {
                            'Authorization': localStorage.getItem('Authorization')
                        }
                    })
                        .then(res => {
                            if (res.data.code === 200){
                                alert('고객사가 삭제 되었습니다.');
                                navigate('/ClientManagement')
                            }else if (res.data.code === 409){
                                alert(res.data.message)
                            }
                        })
                } catch (e) {
                    console.error(e);
                    alert('삭제 실패 하였습니다.');
                }
            }
        })
    }

    const handleModifyCancel = () => {
        const Cancel = window.confirm('취소하시겠습니까?');
        if (Cancel) {
            navigate('/ClientManagement');
        }
    }

    return (
        <div id="wrapper">
            <Sidebar menuCode={"SET0200"}/>
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <div className="container-fluid">
                        <Header pageName='고객사 수정'/>
                        <Card className="card shadow mb-4">
                            <Card.Body style={{margin:'1rem'}}>
                                <Table bordered>
                                    <tbody>
                                    <tr>
                                        <td style={{width: "20%", height:"3rem", verticalAlign: "middle"}} className={styles.tableHead}><p>고객사 코드</p></td>
                                        <td style={{width: "80%", verticalAlign:"middle", color:"black"}}><p>{selectCustomerCode}</p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{width: "20%"}} className={styles.tableHead}><p>고객사 명</p></td>
                                        <td style={{width: "80%"}}><Form.Control type="text" value={customer.customerName}
                                                                                 name="customerName" onChange={handleChange}></Form.Control>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{width: "20%", verticalAlign: 'middle'}} className={styles.tableHead}><p>설명</p>
                                        </td>
                                        <td style={{width: "80%"}}><Form.Control value={customer.description} as="textarea"
                                                                                 style={{height:"10rem"}} name="description"
                                                                                 onChange={handleChange}/>
                                        </td>
                                    </tr>
                                    </tbody>
                                </Table>
                                <div className="btn modify">
                                    <button className="btn btn-primary"
                                            onClick={handleUpdateClient} type="submit">수정
                                    </button>
                                    <button className="btn btn-danger" onClick={handleDeleteClient}>삭제
                                    </button>
                                    <button className="btn btn-secondary" onClick={handleModifyCancel}>취소
                                    </button>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>
                </div>
                <Footer/>
            </div>
        </div>
    )
}

export default ClientModify;